import { SVGProps } from 'react';
import * as React from 'react';

const SvgIcDraggable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="8"
      r="2"
      className="clr-i-outline clr-i-outline-path-1"
    ></circle>
    <circle
      cx="12"
      cy="24"
      r="2"
      className="clr-i-outline clr-i-outline-path-2"
    ></circle>
    <circle
      cx="19"
      cy="8"
      r="2"
      className="clr-i-outline clr-i-outline-path-3"
    ></circle>
    <circle
      cx="19"
      cy="24"
      r="2"
      className="clr-i-outline clr-i-outline-path-4"
    ></circle>
    <circle
      cx="19"
      cy="16"
      r="2"
      className="clr-i-outline clr-i-outline-path-5"
    ></circle>
    <circle
      cx="12"
      cy="16"
      r="2"
      className="clr-i-outline clr-i-outline-path-6"
    ></circle>
    <path fill="currentColor"></path>
  </svg>
);

export default SvgIcDraggable;
